/* ==========================================================================
   Weespice collection toolbar: filter dropdowns, price range, sort.
   Scoped per section instance so more than one can coexist on a page.
   Navigates by URL so it works with Shopify's native storefront filters.
   ========================================================================== */
(function () {
  if (window.wsCollectionToolbarReady) return;
  window.wsCollectionToolbarReady = true;

  function closeAll(except) {
    document.querySelectorAll('.ws-dropdown-content.show').forEach(function (el) {
      if (el !== except) {
        el.classList.remove('show');
        var trigger = el.parentElement && el.parentElement.querySelector('[aria-expanded]');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
      }
    });
  }

  function go(url) {
    window.location.href = url.toString();
  }

  function initToolbar(root) {
    if (!root || root.dataset.wsToolbarBound === 'true') return;
    root.dataset.wsToolbarBound = 'true';

    /* ---- Dropdown toggles ---- */
    root.querySelectorAll('[data-ws-dropdown-trigger]').forEach(function (trigger) {
      trigger.addEventListener('click', function (event) {
        event.stopPropagation();
        var panel = trigger.parentElement.querySelector('.ws-dropdown-content');
        if (!panel) return;
        var willOpen = !panel.classList.contains('show');
        closeAll(panel);
        panel.classList.toggle('show', willOpen);
        trigger.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      });
    });

    /* ---- Availability / other checkbox filters ---- */
    root.querySelectorAll('[data-ws-filter-checkbox]').forEach(function (checkbox) {
      checkbox.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.delete('page');
        if (checkbox.checked) {
          url.searchParams.set(checkbox.name, checkbox.value);
        } else {
          url.searchParams.delete(checkbox.name);
        }
        go(url);
      });
    });

    /* ---- Price range ---- */
    var applyPrice = root.querySelector('[data-ws-apply-price]');
    if (applyPrice) {
      applyPrice.addEventListener('click', function () {
        var gte = root.querySelector('[data-ws-price-gte]');
        var lte = root.querySelector('[data-ws-price-lte]');
        var url = new URL(window.location.href);
        url.searchParams.delete('page');

        if (gte && gte.value !== '') url.searchParams.set('filter.v.price.gte', gte.value);
        else url.searchParams.delete('filter.v.price.gte');

        if (lte && lte.value !== '') url.searchParams.set('filter.v.price.lte', lte.value);
        else url.searchParams.delete('filter.v.price.lte');

        go(url);
      });
    }

    /* ---- Clear all ---- */
    var clearAll = root.querySelector('[data-ws-clear-filters]');
    if (clearAll) {
      clearAll.addEventListener('click', function () {
        var url = new URL(window.location.href);
        Array.from(url.searchParams.keys()).forEach(function (key) {
          if (key.indexOf('filter.') === 0 || key === 'page') url.searchParams.delete(key);
        });
        go(url);
      });
    }

    /* ---- Sort ---- */
    var sort = root.querySelector('[data-ws-sort]');
    if (sort) {
      sort.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sort.value);
        url.searchParams.delete('page');
        go(url);
      });
    }
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-ws-collection-toolbar]').forEach(initToolbar);
  }

  document.addEventListener('click', function (event) {
    if (!event.target.closest('.ws-filter-dropdown-wrap')) closeAll();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeAll();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
